mutation ADD_LOT (
  $description: String,
  $facilityId: UUID!,
  $floor: Int = 1,
  $hasSpaceForBiggerVehicles: Boolean,
  $latitude: String!,
  $longitude: String!,
  $maxHeightSupported: Float,
  $name: String!,
  $parkerInstructions: String,
  $tagIds: [UUID]
) {
  addLot(
    description: $description,
    facilityId: $facilityId,
    floor: $floor,
    hasSpaceForBiggerVehicles: $hasSpaceForBiggerVehicles,
    latitude: $latitude,
    longitude: $longitude,
    maxHeightSupported: $maxHeightSupported,
    name: $name,
    parkerInstructions: $parkerInstructions,
    tagIds: $tagIds,
  ) {
    success
    error
  }
}
